module.exports = __webpack_public_path__ + "static/banner-mobile-gruppo-pam-555630277b7bb70e1fa3187367dd5987.jpg";